import CustomCard from '../../../../../components/CustomCard';
import { IconScheduleTable } from '../../../../../components/buttons/IconButtons';
import React, { useLayoutEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const SectionSelected = (
    {
        title = "booking", children, count=null,
        icon=<IconScheduleTable className={"mr-8px mb-1 icon-color-general-950"} />,
        autoHeight=true
    }
) => {
    const { t } = useTranslation();
    const elementRef = useRef(null);

    useLayoutEffect(() => {
        if (!autoHeight) return;
        if (elementRef?.current) {
            const rect = elementRef.current.getBoundingClientRect();
            const distanceTop = rect.top + 90;
            elementRef.current.style.setProperty('--top-value', `${distanceTop}px`);
        }
    }, []);

    return (
        <>
            <div className={`w-100 card-border-8px border-full-shades-300 ${!autoHeight ? 'flex-grow-1' : ''}`}>
                <div className='d-flex align-items-center p-16px'>
                    <div>{icon}</div>
                    <p className="fs-16px ibl-font-w-600 font-color-general-950 mr-2">{t(title)}</p>

                    { count !== null &&
                        <div className={`d-flex justify-content-center align-items-center border-radius-8px w-20px ${count === 0 ? 'background-shades-200 border-full-shades-150' : 'background-shades-950 border-full-shades-950' } `}>
                            <p className={`fs-14px ibl-font-w-500 ${count === 0 ? 'font-color-shades-500' : 'font-color-shades-50' } px-1`}>{count}</p>
                        </div>
                    }

                </div>

                <div className="border-bottom-shades-300" />

                <div className={`${autoHeight ? 'panelTables-container' : 'flex-grow-1 overflow-auto'} custom-scrollbar`} ref={elementRef}>
                    <CustomCard classes={"w-100"} classCard={'border-0'}>
                        {
                            children
                        }
                    </CustomCard>
                </div>
            </div>
        </>
    );

}

export default SectionSelected
